import React from 'react';
import { useEffect, useState } from "react";
import { RootState, useAppDispatch, useAppSelector } from "../../../../state/state.tsx";
import { auth } from "../../../../Config/firebase.ts";
import {
    checkUserInFirestore,
    saveUserData,
    setAuthenticated,
    setDetailsFromFillDetailsForm,
    uploadProfilePicture
} from "../../../../state/UserStatesV2/userSliceV2.ts";
import { useNavigate } from "react-router-dom";
import { Box, Chip, MenuItem, TextField, Typography } from "@mui/material";
import loginImg from "../../../../assets/Fill-details.png";
import { signOut } from 'firebase/auth';
import { UserStateV2 } from '../../types/UserStateV2.ts';

export const FillDetails: React.FC = () => {

    //  Component states

    const [profilePhoto, setProfilePhoto] = useState<string>('https://firebasestorage.googleapis.com/v0/b/coach-pro-mobile.appspot.com/o/company-logo%2FhosakshamLogo.png?alt=media&token=e4d7b7bb-22ea-4e12-946a-f20e3a333537');
    const [BusinessName, setBusinessName] = useState<string>('');
    const [FullName, setFullName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [, setPhone] = useState<string>('');
    const [Demo, setDemo] = useState<boolean>(true);
    const [businessNameError, setBusinessNameError] = useState<boolean>(false);
    const [fullNameError, setFullNameError] = useState<boolean>(false);
    const [emailError, setEmailError] = useState<boolean>(false);
    const [businessType, setBusinessType] = React.useState<number>(3)
    const navigate = useNavigate();
    const authState = useAppSelector((state: RootState) => (state.userSliceV2.data as UserStateV2)?.isAuthenticated)
    const userSlice = useAppSelector((state: RootState) => state.userSliceV2.data as UserStateV2)
    const Dispatch = useAppDispatch();
    const PhoneNum = useAppSelector((state: RootState) => (state.userSliceV2.data as UserStateV2)?.phone_number) || ""
    const [selectedServiceTypes, setSelectedServiceTypes] = useState<string[]>([])
    const [serviceTypeError, setServiceTypeError] = useState<boolean>(false); // State for service type error
    const [gstin, setGstin] = useState<string>('');
    const [gstinError, setGstinError] = useState<boolean>(false);
    const isLoading = useAppSelector((state: RootState) => (state.userSliceV2.data as UserStateV2)?.loading)

    // ----------- Form Options

    const BusinessTypeOptions: string[] = [
        "llp",
        "ngo",
        "other",
        "individual",
        "partnership",
        "proprietorship",
        "public_limited",
        "private_limited",
        "not_yet_registered",
        "educational_institutes",
    ]

    const ServiceTypes = [
        "Preschool",
        "Creche",
        "Tuition",
        "PGHostels",
        "Rentals",
        "CableTV",
        "Sports",
        "Fitness",
        "Other"
    ]

    useEffect(() => {
        if (navigate && authState !== undefined && userSlice !== undefined) {

            if (authState === true && !userSlice.phone_number) {
              
                signOut(auth).then(() => {
                    Dispatch(setAuthenticated(false))
                    window.location.href = "/login"
                }).catch((error) => {
                    console.error("Logout error:", error);
                });
                return;
            }

            if (authState === true && userSlice.display_name) {
                navigate("/mydashboard");
            
            }
            else if (authState === false) {
        
                window.location.href = "/login"
            }
        }
    }, [authState, navigate, userSlice]);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (!user) {
                Dispatch(setAuthenticated(false))
            
                navigate("/login")
                return;
            }
            if (!user.phoneNumber) {
                Dispatch(setAuthenticated(false))
                
                navigate("/login")
                return;
            }

            Dispatch(checkUserInFirestore(user.uid!));
            Dispatch(setAuthenticated(true));
        });

        return () => unsubscribe();
    }, [Dispatch]);

    function checkError(): boolean {
        validateEmail();
        validateBusinessName();
        validateFullName();
        validateSelectedServiceTypes();
        validateGstin();
        const isError = validateEmail() || validateBusinessName() || validateFullName() || validateSelectedServiceTypes() || validateGstin();
        return isError;
    }

    const handleSave = (): void => {
        if (checkError()) {
            return;
        }

        Dispatch(setDetailsFromFillDetailsForm({
            photo_url: profilePhoto,
            businessProfile: {
                businessName: BusinessName,
                businessType: BusinessTypeOptions[businessType],
            },
            display_name: FullName,
            email: email,
            addDummySubscription: Demo,
            ServiceTypes: selectedServiceTypes,
            notifyOnWhatsApp: true,
            GSTIN: gstin || null 
        }));
        Dispatch(saveUserData());
    };

    const handlePhotoChange = async (e: any) => {
        const file = e.target.files[0];
        const dpUrl: any = await Dispatch(uploadProfilePicture(file))
        await setProfilePhoto(dpUrl.payload);
    };

    const handleChangeBusinessType = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBusinessType(Number(event.target.value))
    }

    // ---------Error Handling functions

    const validateBusinessName = () => {
        if (BusinessName.trim() === '') {
            setBusinessNameError(true)
            return true
        }
        setBusinessNameError(false);
        return false
    };

    const validateFullName = () => {
        if (FullName.trim() === '') {
            setFullNameError(true)
            return true;
        }
        setFullNameError(false)
        return false;
    };

    const validateEmail = () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email.trim() === '') {
            setEmailError(true)
            return true;
        } else if (emailPattern && !emailPattern.test(email)) {
            setEmailError(true)
            return true;
        }
        setEmailError(false);
        return false; // Return true for valid email
    };

    const validateSelectedServiceTypes = () => {
        if (selectedServiceTypes.length === 0) {
            setServiceTypeError(true);
            return true; // Return true if there's an error
        }
        setServiceTypeError(false);
        return false; // Return false if no error
    };

    const validateGstin = () => {
        if (gstin.trim() !== "") {
            const gstinRegex = /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}Z[0-9A-Za-z]{1}$/;
            if (!gstinRegex.test(gstin)) {
                setGstinError(true);
                return true;
            }
        }
        setGstinError(false);
        return false;
    };

    return (
        <div
            className="bg-cc_bg_app py-5 w-full h-auto min-h-screen grid grid-cols-5 overflow-x-hidden">
            <div className={"fillDetails-left relative p-2  h-full col-span-2"}>
                <div className={" h-full  flex bg-cc_brand justify-center items-center rounded-md py-10 shadow-lg"}>
                    <img alt={"*"} className={"h-[95%] w-[100%] max-h-[95vh]  sm:w-[50%] lg:w-[85%] max-w-[700px]"}
                        src={loginImg} />
                </div>

                <div className={"absolute sheet bottom-4 right-0 left-0 px-4 font-medium"}>
                    <div className={"text-xs flex justify-between w-full items-center text-white"}>
                        <div>
                            <p>© 2024, EagleX Sas Makers Pvt. Ltd. All Rights Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-span-3 flex justify-center items-center'>


                <div className="max-w-4xl w-full px-4 col-span-3">
                    <div className="bg-white rounded-xl shadow-lg p-4 sm:p-7">
                        <div className="mb-8">
                            <h2 className="text-xl font-bold text-gray-800">Setup Your Profile</h2>
                            <p className="text-sm text-gray-600">Manage your Business Name, Email and account settings.</p>
                        </div>

                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="grid sm:grid-cols-12 gap-2 sm:gap-6">
                                <div className="sm:col-span-3">
                                    <label className="inline-block text-sm text-gray-800 mt-2.5">Profile photo</label>
                                </div>
                                <div className="sm:col-span-9">
                                    <div className="flex items-center gap-5">
                                        <img className="inline-block size-16 rounded-full ring-2 ring-white"
                                            src={profilePhoto}
                                            alt="Profile" />
                                        <div className="flex gap-x-2">
                                            <div>
                                                <input
                                                    type="file"
                                                    id="upload-photo"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={handlePhotoChange}
                                                />
                                                <label htmlFor="upload-photo"
                                                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none cursor-pointer">
                                                    <svg className="flex-shrink-0 size-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                                        strokeLinejoin="round">
                                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                        <polyline points="17 8 12 3 7 8" />
                                                        <line x1="12" x2="12" y1="3" y2="15" />
                                                    </svg>
                                                    Upload Business Logo
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="af-account-full-name"
                                        className="inline-block text-sm text-gray-800 mt-2.5">Name*</label>
                                    <div className="hs-tooltip inline-block">

                                    </div>
                                </div>
                                <div className="sm:col-span-9">
                                    <div className="sm:flex">

                                        <TextField
                                            onChange={(e) => setFullName(e.target.value)}
                                            value={FullName}
                                            size={"small"}
                                            onBlur={() => {
                                                validateFullName(); // Call the function without using its return value
                                            }}
                                            required={true}
                                            id="Full Name"
                                            label="Full Name"
                                            error={fullNameError}

                                            variant="outlined"
                                            fullWidth={true}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px'// Default border color
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey', // Border color on hover
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue', // Border color when focused
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px', // Setting font size
                                                    },
                                                },
                                                fontWeight: 400,
                                                fontSize: "1px",

                                            }}
                                        />

                                    </div>
                                    {fullNameError && <p className={"px-3 text-red-600 text-xs "}>Name is Required*</p>}
                                </div>


                                <div className="sm:col-span-3">
                                    <label htmlFor="af-account-Business-name"
                                        className="inline-block text-sm text-gray-800 mt-2.5">Business
                                        name*</label>
                                    <div className="hs-tooltip inline-block">

                                    </div>
                                </div>

                                <div className="sm:col-span-9">
                                    <div className="sm:flex">
                                        <TextField
                                            onChange={(e) => setBusinessName(e.target.value)}
                                            value={BusinessName}
                                            size={"small"}
                                            onBlur={() => {
                                                validateBusinessName(); // Call the function without using its return value
                                            }}
                                            required={true}
                                            id="Business Name"
                                            label="Business Name"
                                            error={businessNameError}
                                            variant="outlined"
                                            fullWidth={true}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px'// Default border color
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey', // Border color on hover
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue', // Border color when focused
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px', // Setting font size
                                                    },
                                                },
                                                fontWeight: 400,
                                                fontSize: "1px",

                                            }}
                                        />

                                    </div>
                                    {businessNameError &&
                                        <p className={"px-3  text-red-600 text-xs "}>Business Name is Required</p>}
                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="af-account-email"
                                        className="inline-block text-sm text-gray-800 mt-2.5">Email</label>
                                    <span className="text-sm text-gray-400 ">
                                        *
                                    </span>

                                </div>

                                <div className="sm:col-span-9">
                                    <TextField
                                        onChange={(e) => setEmail(e.target.value)}
                                        value={email}
                                        size={"small"}
                                        onBlur={() => {
                                            validateEmail(); // Call the function without using its return value
                                        }}
                                        required={true}
                                        id="Email-fill"
                                        label="Email"
                                        error={emailError}
                                        variant="outlined"
                                        placeholder={"maria@gmail.com"}
                                        fullWidth={true}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: 'grey',
                                                    borderRadius: '10px'// Default border color
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'grey', // Border color on hover
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'skyblue', // Border color when focused
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '14px', // Setting font size
                                                },
                                            },
                                            fontWeight: 400,
                                            fontSize: "1px",

                                        }}
                                    />
                                    {emailError && <p className={"px-3 text-red-600 text-xs "}>Invalid Email</p>}
                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="af-account-email"
                                        className="inline-block text-sm text-gray-800 mt-2.5">Business Type</label>
                                    <span className="text-sm text-gray-400 ">
                                        *
                                    </span>

                                </div>

                                <div className="sm:col-span-9">
                                    <TextField
                                        size={"small"}
                                        id="BusinessType"
                                        select
                                        fullWidth={true}
                                        label="BusinessType"
                                        defaultValue={"individual"}
                                        value={businessType}
                                        onChange={handleChangeBusinessType}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: 'grey',
                                                    borderRadius: '10px'// Default border color
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'grey',
                                                    // Border color on hover
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'skyblue', // Border color when focused
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '14px', // Setting font size
                                                },
                                            },
                                            fontWeight: 400,
                                            fontSize: "1px",
                                        }}
                                    >
                                        {BusinessTypeOptions.length > 0 ?
                                            BusinessTypeOptions.map((option, index) => (
                                                <MenuItem key={index} value={index}>
                                                    {option}
                                                </MenuItem>
                                            )) :
                                            <MenuItem key="0" value={0}>
                                                No Options Found
                                            </MenuItem>
                                        }

                                    </TextField>
                                </div>

                                <div className="sm:col-span-3">
                                    <div className="inline-block">
                                        <label htmlFor="af-account-Services "
                                            className="inline-block text-sm text-gray-800 mt-2.5">Select the Services you offer</label>

                                    </div>
                                </div>



                                <div className="sm:col-span-9">
                                    <Box>
                                        <Typography variant="body2" color={serviceTypeError ? "error" : "text.secondary"} mb={1}>
                                            Service Types {serviceTypeError && "- At least one service type must be selected"}
                                        </Typography>
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                            {ServiceTypes.map((type) => (
                                                <Chip
                                                    key={type}
                                                    label={type}
                                                    onClick={() => {
                                                        setSelectedServiceTypes(prev => {
                                                            if (prev.includes(type)) {
                                                                if (prev.length === 1) return prev;
                                                                return prev.filter(t => t !== type);
                                                            } else {
                                                                return [...prev, type];
                                                            }
                                                        });
                                                    }}
                                                    color={selectedServiceTypes.includes(type) ? "primary" : "default"}
                                                    variant={selectedServiceTypes.includes(type) ? "filled" : "outlined"}
                                                    sx={{
                                                        '&:hover': {
                                                            backgroundColor: selectedServiceTypes.includes(type)
                                                                ? 'primary.dark'
                                                                : 'action.hover'
                                                        }
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                        {serviceTypeError && <p className={"px-3 text-red-600 text-xs "}>At least one service type must be selected.</p>}
                                    </Box>
                                </div>


                                <div className="sm:col-span-3">
                                    <div className="inline-block">
                                        <label htmlFor="af-account-phone"
                                            className="inline-block text-sm text-gray-800 mt-2.5">Phone</label>
                                    </div>
                                </div>

                                <div className="sm:col-span-9">
                                    <div className="sm:flex">
                                        <input id="af-account-phone" readOnly={true} type="text"
                                            className="py-2 px-3 pe-11 block w-full cursor-not-allowed border-gray-200 shadow-sm -mt-px -ms-px  sm:mt-0 sm:first:ms-0 rounded-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"
                                            placeholder="+x(xxx)xxx-xx-xx" value={PhoneNum}
                                            onChange={(e) => setPhone(e.target.value)} />

                                    </div>

                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="af-account-gender-checkbox"
                                        className="inline-block text-sm text-gray-800 mt-2.5">Setup Demo
                                        Subscription</label>
                                </div>

                                <div className="sm:col-span-9">
                                    <div className="sm:flex">
                                        <label htmlFor="af-account-gender-checkbox"
                                            className="flex py-2 px-3 w-full border border-gray-200 shadow-sm -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none">
                                            <input type="radio" name="af-account-gender-checkbox"
                                                className="shrink-0 mt-0.5 border-gray-300 rounded-full text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"
                                                id="af-account-gender-checkbox" checked={Demo === true}
                                                onChange={() => setDemo(true)} />
                                            <span className="text-sm text-gray-500 ms-3">Yes</span>
                                        </label>
                                        <label htmlFor="af-account-gender-checkbox-female"
                                            className="flex py-2 px-3 w-full border border-gray-200 shadow-sm -mt-px -ms-px first:rounded-t-lg last:rounded-b-lg sm:first:rounded-s-lg sm:mt-0 sm:first:ms-0 sm:first:rounded-se-none sm:last:rounded-es-none sm:last:rounded-e-lg text-sm relative focus:z-10 focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none">
                                            <input type="radio" name="af-account-gender-checkbox"
                                                className="shrink-0 mt-0.5 border-gray-300 rounded-full text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none"
                                                id="af-account-gender-checkbox-female" checked={Demo === false}
                                                onChange={() => setDemo(false)} />
                                            <span className="text-sm text-gray-500 ms-3">No</span>
                                        </label>

                                    </div>
                                </div>

                                <div className="sm:col-span-3">
                                    <label htmlFor="gstin"
                                        className="inline-block text-sm text-gray-800 mt-2.5">GSTIN</label>
                                    <span className="text-sm text-gray-400">
                                        (Optional)
                                    </span>
                                </div>

                                <div className="sm:col-span-9">
                                    <TextField
                                        onChange={(e) => setGstin(e.target.value.toUpperCase())}
                                        value={gstin}
                                        size={"small"}
                                        id="GSTIN"
                                        label="GSTIN (Optional)"
                                        error={gstinError}
                                        variant="outlined"
                                        fullWidth={true}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: 'grey',
                                                    borderRadius: '10px'
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: 'grey',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: 'skyblue',
                                                },
                                                '& .MuiInputBase-input': {
                                                    fontSize: '14px',
                                                },
                                            },
                                            fontWeight: 400,
                                            fontSize: "1px",
                                        }}
                                    />
                                    {gstinError && <p className={"px-3 text-red-600 text-xs "}>Invalid GSTIN format</p>}
                                </div>

                            </div>

                            <div className="mt-5 flex justify-end gap-x-2">
                                <button
                                    type="button"
                                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-gray-200 text-gray-800 hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none"
                                    onClick={() => {
                                        signOut(auth).then(() => {
                                            Dispatch(setAuthenticated(false));
                                            window.location.href = "/login"
                                        }).catch((error) => {
                                            console.error("Logout error:", error);
                                        });
                                    }}
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                                    </svg>
                                    Back
                                </button>
                                <button
                                    type="button"
                                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
                                    onClick={handleSave}
                                >
                                    Save changes
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};